// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foam-tests-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  min-width: 0;
  color: #fff;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
}

.foam-tests-toggle input {
  margin: 0;
}

.foam-tests-title {
  font-size: 15px;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
  color: #fff;
}

.foam-test-section-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.foam-tests-empty-state {
  padding: 12px 14px;
  border: 1px dashed #cfdae5;
  border-radius: 4px;
  background: #f7fbff;
  color: #53657a;
  font-size: 12px;
}

.validated-test-input {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.validated-test-input .tab-input {
  flex: 1 1 auto;
  min-width: 0;
}

.validation-input-invalid {
  border-color: #c62828 !important;
}

.validation-field-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border-radius: 50%;
  background: #c62828;
  color: #fff;
  font-weight: 700;
  line-height: 1;
}

.foam-notes-row {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  margin-top: 2px;
}

.foam-notes-row > label {
  margin: 0;
  min-width: 0;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
}

.foam-notes-row textarea.tab-input {
  width: 100% !important;
  max-width: none !important;
  min-height: 96px;
  resize: vertical;
  line-height: 1.4;
}

@media (max-width: 960px) {
  .foam-notes-row {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-details/tabs/slurry-foam-tab/slurry-foam-tab.component.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".foam-tests-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  min-width: 0;\n  color: #fff;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n}\n\n.foam-tests-toggle input {\n  margin: 0;\n}\n\n.foam-tests-title {\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n  color: #fff;\n}\n\n.foam-test-section-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.foam-tests-empty-state {\n  padding: 12px 14px;\n  border: 1px dashed #cfdae5;\n  border-radius: 4px;\n  background: #f7fbff;\n  color: #53657a;\n  font-size: 12px;\n}\n\n.validated-test-input {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.validated-test-input .tab-input {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.validation-input-invalid {\n  border-color: #c62828 !important;\n}\n\n.validation-field-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  border-radius: 50%;\n  background: #c62828;\n  color: #fff;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.foam-notes-row {\n  display: grid;\n  grid-template-columns: 190px minmax(0, 1fr);\n  gap: 8px;\n  align-items: start;\n  margin-top: 2px;\n}\n\n.foam-notes-row > label {\n  margin: 0;\n  min-width: 0;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n}\n\n.foam-notes-row textarea.tab-input {\n  width: 100% !important;\n  max-width: none !important;\n  min-height: 96px;\n  resize: vertical;\n  line-height: 1.4;\n}\n\n@media (max-width: 960px) {\n  .foam-notes-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
